import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { useContext, useMemo } from 'react';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import { storesContext } from '../../../stores/storesContext';
import useUserBlocks from '../../helpers/hooks/useUserBlocks';
import useUserReports from '../../helpers/hooks/useUserReports';
import DashboardMap from './DashboardMap';
import PropertiesReports from './PropertiesReports';

const BlockScanningDashboard = (props) => {
  const userStore = useContext(storesContext);
  const propertiesStore = userStore.propertiesStore;
  const userBlocks = useUserBlocks();
  const userReports = useUserReports();

  const propertiesLoading = propertiesStore.loading;

  const blocksFeatures = useMemo(
    () =>
      userBlocks.flatMap((block) => {
        const features = [];
        const blockClusters = block.block_clusters;
        blockClusters.forEach((blockCluster) => {
          const feature = JSON.parse(
            blockCluster.primary_ga_block.geojson_feature
          );
          const reports = userReports.find(
            (report) => report.property_id === block.property_id
          );
          const property = propertiesStore.properties.find(
            (property) => property.id === block.property_id
          );
          feature.properties.has_reports = reports?.reports.length > 0;
          feature.properties.property = {
            id: property?.id || '-',
            name: property?.name || '-',
            identifier: property?.identifier || '-'
          };
          features.push(feature);
        });
        return [...features];
      }),
    [propertiesStore.properties, userBlocks, userReports]
  );

  return props.loading ? (
    <div className='d-flex justify-content-center pt-5'>
      <Spinner animation='border' variant='primary' />
    </div>
  ) : (
    <Container className='p-0'>
      <Row className='mt-4' style={{ height: '400px' }}>
        <Col>
          <DashboardMap features={blocksFeatures} />
        </Col>
      </Row>
      <Row>
        <Col>
          {propertiesLoading ? (
            <div className='text-center'>
              <Spinner className='my-4' animation='border' variant='primary' />
            </div>
          ) : (
            <PropertiesReports
              userReports={userReports}
              userBlocks={userBlocks}
            />
          )}
        </Col>
      </Row>
    </Container>
  );
};

BlockScanningDashboard.propTypes = {
  loading: PropTypes.bool.isRequired
};

export default observer(BlockScanningDashboard);

